// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2S64a","comment":"styles_comment__1-xzT"};